// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-shadow[data-v-12397836]{box-shadow:0px 4px 24px rgba(1,3,20,.08)}.align-title[data-v-12397836]{width:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
